export default{
    setAirports(state, payload){
        state.airports = payload;
    },
    setPrice(state,payload){
        state.price = payload;
    }
}